import RelationsCircle from "./RelationsCircle.svelte";
import BindCardWidget from "./BindCardWidget.svelte";
import SignUpForm from "./auth/SignUpForm.svelte";
import SignInForm from "./auth/SignInForm.svelte";
import PasswordResetForm from "./auth/PasswordResetForm.svelte";
import ChangePasswordForm from "./auth/ChangePasswordForm.svelte";
import NewSignInForm from "./auth/NewSignInForm.svelte";
import NewPasswordResetForm from "./auth/NewPasswordResetForm.svelte";
import NewChangePasswordForm from "./auth/NewChangePasswordForm.svelte";
import ZencpaModalWidget from "./ZencpaModalWidget.svelte";
import NewSignUpForm from "./auth/NewSignUpForm.svelte";

function createRelationsCircleModal(wrapId, params = {}) {
    return new RelationsCircle({
        target: document.getElementById(wrapId),
        props: params
    });
}

function createBindCardWidget(wrapId, params = {}) {
    return new BindCardWidget({
        target: document.getElementById(wrapId),
        props: params
    });
}


window['createRelationsCircleModal'] = createRelationsCircleModal;
window['createBindCardWidget'] = createBindCardWidget;


window['signUpFormSpyRegister'] = (target, props) => {
    return new SignUpForm({target, props});
};

window['signInFormSpyRegister'] = (target, props) => {
    return new SignInForm({target, props});
};

window['newSignInFormSpyRegister'] = (target, props) => {
    return new NewSignInForm({target, props});
};

window['newSignUpFormSpyRegister'] = (target, props) => {
    return new NewSignUpForm({target, props});
};

window['passwordResetFormSpyRegister'] = (target, props) => {
    return new PasswordResetForm({target, props});
};

window['newPasswordResetFormSpyRegister'] = (target, props) => {
    return new NewPasswordResetForm({target, props});
};

window['changePasswordFormSpyRegister'] = (target, props) => {
    return new ChangePasswordForm({target, props});
};

window['newChangePasswordFormSpyRegister'] = (target, props) => {
    return new NewChangePasswordForm({target, props});
};

window['createZencpaModalWidget'] = (target, props) => {
    return new ZencpaModalWidget({target, props});
};